import JustValidate from 'just-validate';
import IMask from 'imask';

document.addEventListener('DOMContentLoaded', () => {
	const phoneMask = new IMask(
		document.getElementById('phone'),
		{
			mask: '+{7}(000)000-00-00',
		});

	const innMask = new IMask(
		document.getElementById('inn'),
		{
			mask: Number,
			signed: false
		});

	const applicantForm = document.getElementById('joinForm');

	async function sendData(data) {
		return fetch('https://a-ai.ru/apply', {
			method: 'POST',
			headers: {'Content-Type': 'application/x-www-form-urlencoded'},
			body: data,
		});
	}

	function serializeForm(formNode) {
		let data = new URLSearchParams(Object.fromEntries(new FormData(formNode)));
		console.log(data.toString());
		return data.toString();
	}

	async function handleFormSubmit(event) {
		event.preventDefault();
		const data = serializeForm(applicantForm);
		const response = await sendData(data);
		if (response.ok) {
			let blob = await response.blob();
			const href = window.URL.createObjectURL(blob);
			const a = document.createElement('a');
			a.href = href;
			a.download = 'apply.docx';
			document.body.appendChild(a);
			a.click();
			a.remove();
		} else {
			alert("Ошибка HTTP: " + response.status);
		}
		event.target.reset();
		// document.querySelector('.join-form__content').classList.add('hidden');
		// document.querySelector('.join-form__thanks').classList.remove('hidden');
	}

	const validation = new JustValidate('#joinForm', {
		errorFieldCssClass: 'is-invalid',
	});

	validation
		.addField('#fio', [
			{
				rule: 'required',
				errorMessage: 'Обязательное поле',
			},
		])
		.addField('#fiop', [
			{
				rule: 'required',
				errorMessage: 'Обязательное поле',
			},
		])
		.addField('#spos', [
			{
				rule: 'required',
				errorMessage: 'Обязательное поле',
			},
		])
		.addField('#phone', [
			{
				rule: 'required',
				errorMessage: 'Обязательное поле',
			},
			{
				rule: 'minLength',
				value: 16,
				errorMessage: 'Некорректный номер телефона',
			},
		])
		.addField('#dolg', [
			{
				rule: 'required',
				errorMessage: 'Обязательное поле',
			},
		])
		.addField('#inn', [
			{
				rule: 'required',
				errorMessage: 'Обязательное поле',
			},
		])
		.addField('#dolgp', [
			{
				rule: 'required',
				errorMessage: 'Обязательное поле',
			},
		])
		.addField('#policy', [
			{
				rule: 'required',
				errorMessage: '',
			},
		])
		.addField('#dataProcessing', [
			{
				rule: 'required',
				errorMessage: '',
			},
		])
		.addField('#org', [
			{
				rule: 'required',
				errorMessage: 'Обязательное поле',
			},
		])
		.addField('#email', [
			{
				rule: 'required',
				errorMessage: 'Обязательное поле',
			},
			{
				rule: 'email',
				errorMessage: 'Некорректный email',
			},
		])
		.onSuccess(handleFormSubmit);
});
